<template>
  <div class="m-b-40 card card-1 draftResponseCard">
     <b-row class="m-b-60">
       <b-col cols="10">
         <h3 class="m-t-5">Drafts Response Statistics for Remaining (Last {{ selected }} Days) </h3>
         <b-form-checkbox
            id="checkbox-1"
            v-model="physicalOrderStatus"
            name="checkbox-1"
            value="physical_present"
            unchecked-value="physical_not_compulsory"
            @input="fetchDraftsResponseStatistics"
          >
            At least 1 Physical Item Present
          </b-form-checkbox>
       </b-col>
       <b-col cols="2">
          <b-form-select v-model="selected" :options="options" @change="fetchDraftsResponseStatistics"></b-form-select>
       </b-col>
     </b-row>
     <b-row class="m-b-30">
       <b-col cols="4" class="text-success text-center">
          <section class="single-grid">
            <h4>Approved</h4>
            <p>Print Status Not Set Or No Ship. IDs Found after Draft</p>
            
              <b-badge variant="success" class="myBadge">{{ stats.totalApproved }}</b-badge>
            
          </section>
       </b-col>
       <b-col cols="4" class="text-danger text-center">
          <section class="single-grid">
            <h4>Revision Requested</h4>
            <p>Draft not resent. Only unique Drafts selected</p>
            <b-badge variant="danger" class="myBadge">{{ stats.totalUnapproved }}</b-badge>
          </section>
       </b-col>
       <b-col cols="4" class="text-dark text-center">
          <section class="single-grid noborder">
            <h4>Not Touched</h4>
            <p>Print Status Not Set Or No Ship. IDs Found after Draft</p>
            <b-badge variant="dark" class="myBadge">{{ stats.totalNotTouched }}</b-badge>
          </section>
       </b-col>
     </b-row>
     <p class="light-note">
       <strong>Note 1 :</strong> Draft Response with unique order number are selected. No drafts response with duplicate order number present.
     </p>
     <p class="light-note">
       <strong>Note 2 :</strong> The accuracy of the stats depends on how well the staff has updated the statuses such as "Send for Print", etc.
     </p>
  </div>
</template>

<script>
 import DashboardService from '../../../services/dashboard.service';
  export default {
     data(){
       return {
          stats: {},
          selected: 30,
          options: [
            { value: 15, text: '15' },
            { value: 30, text: '30' },
            { value: 45, text: '45' },
            { value: 60, text: '60' },
            { value: 75, text: '75' },
            { value: 90, text: '90' },
          ],
          physicalOrderStatus: 'physical_present'
       }
     },
     mounted(){
       this.fetchDraftsResponseStatistics();
     },
     methods: {
       async fetchDraftsResponseStatistics(){
          try{
            const result = await DashboardService.fetchDraftsResponseStatistics(this.storeInState.id, this.selected, this.physicalOrderStatus)
            this.stats = result.data.stats;
          }catch(errors){
            console.log('Error while fetching draft statistics', errors)
          }
       }
     },
     computed:{
       storeInState(){
         return this.$store.state.ecommerceStore.store
       }
     },
     watch: {
       storeInState(newValue, oldValue){
          this.fetchDraftsResponseStatistics(this.storeInState.id)
       }
     }
  }
</script>

<style lang="scss" scoped>
  .draftResponseCard{
    padding: 30px 30px 10px 30px;
  }
  .myBadge{
    font-size: 22px;
  }
  .single-grid{
    border-right: 1px solid rgb(219, 219, 219);
    &.noborder{
      border:none;
    }
  }
 
</style>